import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, LookupChange } from '../../../../../../system/system-dtos';
import { isDefined, isNotEmpty, notDefined } from '../../../../../utils/utils';
import { LookupService } from '../../lookup/lookup.service';

interface OptionPanelRequest {
  conditionals?: string[];
}

interface OptionPanelResponse {
  data: Map<string, Map<string, any>>;
  panels: Map<string, any[]>;
}

interface ISelectedPanel {
  selectedOption: string;
  data: Map<string, Map<string, any>>;
}

@Component({
  selector: 'app-form-field-option-panel',
  templateUrl: './option-panel-form-field.component.html',
  standalone: false,
})
export class OptionPanelFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  options: any[] = undefined;

  optionData: any;

  panels: Map<string, any[]> = undefined;

  panelData: Map<string, Map<string, any>> = undefined;

  lookupSubscription: Subscription;

  keyFieldId: string = undefined;

  selectedOption: string;

  selectedOptionData: ISelectedPanel;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  // lookupWatcher: LookupWatcher = {
  //     field: 'event',
  //     objectId: 'id'
  // }

  constructor(
    private http: HttpClient,
    private lookupService: LookupService
  ) {
    super();
  }

  ngOnDestroy() {
    if (isDefined(this.lookupSubscription)) {
      this.lookupSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.lookupSubscription = this.lookupService.getLookupChangeSubject().subscribe((incomingChange: LookupChange) => {
      if (isDefined(incomingChange) && isDefined(this.fieldConfig.lookupWatcherFieldName)) {
        if (
          incomingChange.field === this.fieldConfig.lookupWatcherFieldName &&
          isDefined(incomingChange.value) &&
          isDefined(this.fieldConfig.lookupWatcherFieldObjectId)
        ) {
          if (
            notDefined(this.keyFieldId) ||
            (isDefined(this.keyFieldId) &&
              this.keyFieldId !== incomingChange.value[this.fieldConfig.lookupWatcherFieldObjectId])
          ) {
            this.keyFieldId = incomingChange.value[this.fieldConfig.lookupWatcherFieldObjectId];
            this.getPanelOptions();
          }
        }
      }
    });
  }

  private getPanelOptions() {
    if (isNotEmpty(this.fieldConfig.panelOptionsUrl)) {
      // let selectAllUrl: string = this.fieldConfig.panelOptionsUrl.replace('{id}', this.keyFieldId);
      this.http.post(this.fieldConfig.panelOptionsUrl, { id: this.keyFieldId } as OptionPanelRequest).subscribe(
        (response: OptionPanelResponse) => {
          if (isDefined(response) && isDefined(response.panels)) {
            if (isDefined(response.panels)) {
              this.panels = response.panels;
              this.panelData = response.data;
              const options = [];
              Object.keys(this.panels).forEach((key) => {
                options.push(key);
              });

              this.options = options;
              if (this.options.length > 0) {
                this.onOptionChange(this.options[0]);
              }
            }
          } else {
            this.options = undefined;
            this.selectedOption = undefined;
            this.selectedOptionData = undefined;
            this.fields = undefined;
            this.selectedFieldConfig = undefined;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  onOptionChange(option: string, $event?: MatOptionSelectionChange) {
    if ((isDefined($event) && !$event.isUserInput) || (this.selectedOption && option === this.selectedOption)) {
      return;
    }
    this.selectedOption = option;
    this.selectedOptionData = { selectedOption: option, data: this.panelData[option] } as ISelectedPanel;
    this.formGroup.get(this.fieldConfig.name).setValue(option);
    this.fields = [];
    if (this.panels[option]) {
      this.panels[option].forEach((row) => {
        row.columns.forEach((column) => {
          column.fields.forEach((f) => {
            this.fields.push(f);
          });
        });
      });
    }
    this.selectedFieldConfig = {
      name: 'panelData',
      label: option,
      type: 'sub_panel',
      strippedRows: true,
    } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }
}
